export default __webpack_public_path__ + "static/media/spring-solar-logo.efa16f41.png";